import React from 'react';
import { Mail, MapPin, Heart } from 'lucide-react';

const LOGO_URL = "https://media.base44.com/images/public/user_6925d9d627c76e39d999f15c/60a86ee92_1000151345.png";

export default function Footer() {
  return (
    <footer id="contact" className="bg-accent text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img src={LOGO_URL} alt="Rose of Jericho" className="h-16 w-auto mb-4 brightness-0 invert" />
            <p className="text-white/60 text-sm leading-relaxed">
              Rose of Jericho Community Development Center — Your place for transformation and restoration.
              A recognized 501(c)(3) non-profit organization.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Mission', 'About', 'Our Vision', 'Programs', 'Impact', 'Partners'].map(link => (
                <li key={link}>
                  <button
                    onClick={() => {
                      const id = link === 'Our Vision' ? 'phases' : link.toLowerCase();
                      document.querySelector(`#${id}`)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/60 text-sm">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:info@roseofjericho-cd.org" className="hover:text-white transition-colors">
                  info@roseofjericho-cd.org
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/60 text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                <span>Riverside County, California</span>
              </li>
            </ul>
            <div className="mt-6">
              <a
                href="https://www.paypal.me/roseofjerichocd?locale.x=en_US"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-5 py-2.5 rounded-full text-sm font-medium transition-colors"
              >
                <Heart className="w-4 h-4" />
                Donate Now
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-white/40 text-xs">
          <p>© {new Date().getFullYear()} Rose of Jericho Community Development Center. All rights reserved.</p>
          <p className="mt-1">EIN: 37-1643488 | Tax-Exempt Organization</p>
        </div>
      </div>
    </footer>
  );
}